import React from 'react';
import {Link, useNavigate} from 'react-router-dom';
import './LeftPanel.css'
import api from '../contexts/BaseUrl'
import HomeIcon from '../icons/HomeIcon'

import DollarIcon from '../icons/SalesIcon'
import SettingsIcon from '../icons/SettingsIcon';

import LogoutIcon from '../icons/LogoutIcon';
import { useState,useEffect,useCallback,useContext } from 'react';
import { UnitShadeContext } from "../contexts/UnitShadeContext";

import DueIcon from '../icons/DueIcon';

const LeftPanel = (props) =>{
    
    const { unitShadeNo, setUnitShadeNo } = useContext(UnitShadeContext);
    const token = JSON.parse(localStorage.getItem('auth')).token;
    const {tabName} = props;
    const navigate = useNavigate();
    const [allUnitShades,setAllUnitShades] = useState([]);
    
    

    const handleLogout = () => {
        localStorage.removeItem('auth');
        localStorage.removeItem('unitShade');
        navigate('/login')
    }

    

    const fetchAllUnitShades = useCallback( async () => {
        await api.get(`unitShades/get-all-unit-shades`,{
            headers:{Authorization:`Bearer ${token}`}
        }).then(response =>{
            setAllUnitShades(response.data);
        })
    },[token])

    useEffect(() => {
        //localStorage.setItem("unitShade", unitShadeNo);
        fetchAllUnitShades();
    },[fetchAllUnitShades])

    return(
        <div className='leftPanel'>
            <div id='headerText'>Porichorja</div>
            <div id='headerTextRed'>Farm</div>

            <select 
                required 
                id='chooseBox'
                onChange={(e) => setUnitShadeNo(Number(e.target.value))}
                value={unitShadeNo}
            >
                <option value="">Choose Shade</option>
                {allUnitShades.map(item => (
                    <option key={item.unitShadeId} value={item.unitShadeId}>{item.unitShadeName}</option>
                ))}
            </select>
            <Link 
                to='/'
                className='homeTabBox'
                style={tabName==='home' ?
                {
                    backgroundColor:'#e7e5ff'
                }:{
                    backgroundColor:'white'
                }}
            >
                {tabName ==='home' &&
                    <div style={{ width: 5, height: 45, backgroundColor: '#978CF3' }} />                
                }
                <HomeIcon 
                    size={24} 
                    style={{marginTop:7,marginLeft: tabName === 'home' ? 25 : 30}} 
                    
                />
                <div className='tabText' 
                    style={tabName==='home' ? {fontFamily:'LexendBold' }:{fontFamily:'LexendMedium'}}
                >Home</div>
            </Link> 
            <Link 
                to = '/sales'
                className='purchaseTabBox'
                style={tabName==='sales' ?
                {
                    backgroundColor:'#e7e5ff'
                }:{
                    backgroundColor:'white'
                }}
            >
                {tabName ==='sales' &&
                    <div style={{ width: 5, height: 45, backgroundColor: '#978CF3' }} />                
                }
                 <DueIcon 
                    size={24} 
                    style={{marginTop:10, marginLeft:tabName === 'sales' ? 25:30}} 
                    
                />
                <div className='dailyExpenseTabText' 
                    style={tabName==='sales' ? {fontFamily:'LexendBold' }:{fontFamily:'LexendMedium'}}
                >Sales</div>
            </Link>
            <Link 
                to = '/daily-expense'
                className='purchaseTabBox'
                style={tabName==='daily-expense' ?
                {
                    backgroundColor:'#e7e5ff'
                }:{
                    backgroundColor:'white'
                }}
            >
                {tabName ==='daily-expense' &&
                    <div style={{ width: 5, height: 45, backgroundColor: '#978CF3' }} />                
                }
                 <DollarIcon 
                    size={24} 
                    style={{marginTop:10, marginLeft:tabName === 'daily-expense' ? 25:30}} 
                    
                />
                <div className='dailyExpenseTabText' 
                    style={tabName==='daily-expense' ? {fontFamily:'LexendBold' }:{fontFamily:'LexendMedium'}}
                >Daily Expense</div>
            </Link>
           
            
            
           
           
            
            
            <Link 
                to='/settings'
                className='purchaseTabBox'
                style={tabName==='settings' ?
                {
                    backgroundColor:'#e7e5ff'
                }:{
                    backgroundColor:'white'
                }}
            >
                {tabName ==='settings' &&
                    <div style={{ width: 5, height: 45, backgroundColor: '#978CF3' }} />                
                }
                <SettingsIcon 
                    size={24} 
                    style={{marginTop:10,marginLeft: tabName === 'settings' ? 25 : 30}} 
                    color='black'
                />
                <div className='tabText' 
                    style={tabName==='settings' ? {fontFamily:'LexendBold' }:{fontFamily:'LexendMedium'}}
                >Settings</div>
            </Link>
            
            <div className='logoutIcon' onClick={handleLogout}>
                <LogoutIcon size={70} style={{marginLeft:15}} />
                <div id='logoutText'>Logout</div>
            </div>
            
        </div>
    )
}

export default LeftPanel;